import { useNavigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

export default function Iec62443() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <section className="blueprint border-b border-slate-200">
        <div className="mx-auto max-w-4xl px-5 py-16 lg:px-8 lg:py-24">
          <p className="overline text-navy-800">IEC 62443-4-1 &amp; 4-2</p>
          <h1 className="mt-5 font-display text-4xl font-extrabold leading-tight text-navy-900 sm:text-5xl">
            Process maturity and component capability, assessed separately
          </h1>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            Industrial customers ask two different questions: how you build the product, and what the
            product itself can do. We score both independently so a strong development process never
            hides a weak device, and vice versa.
          </p>
          <Button
            size="lg"
            className="mt-9 bg-navy-800 text-white hover:bg-navy-700"
            onClick={() => navigate("/register")}
            data-testid="iec-start-button"
          >
            Start an IEC 62443 readiness check <ArrowRight size={17} className="ml-2" />
          </Button>
        </div>
      </section>

      <section className="mx-auto grid max-w-6xl gap-8 px-5 py-16 lg:grid-cols-2 lg:px-8">
        <div className="border border-slate-200 bg-white p-8">
          <p className="overline text-navy-800">IEC 62443-4-1</p>
          <h2 className="mt-3 font-display text-xl font-bold text-navy-900">Secure development lifecycle</h2>
          <ul className="mt-5 space-y-3 text-sm leading-relaxed text-slate-600">
            <li>Security requirements definition and risk assessment before development starts</li>
            <li>Threat modelling of architecture and external interfaces</li>
            <li>Secure coding practice, static analysis and build integrity</li>
            <li>Security verification, robustness testing and independent testing</li>
            <li>Vulnerability handling, advisories and incident response</li>
            <li>Supplier flow-down of security requirements</li>
          </ul>
        </div>
        <div className="border border-slate-200 bg-white p-8">
          <p className="overline text-navy-800">IEC 62443-4-2</p>
          <h2 className="mt-3 font-display text-xl font-bold text-navy-900">Component technical capability</h2>
          <ul className="mt-5 space-y-3 text-sm leading-relaxed text-slate-600">
            <li>Unique identification and authentication of users and machines</li>
            <li>Elimination of shared or default credentials</li>
            <li>Least-privilege authorisation and controlled remote access</li>
            <li>Transport and storage protection, input validation on all interfaces</li>
            <li>Verified boot, signed firmware update and rollback protection</li>
            <li>Security event logging, log export and resilience under load</li>
          </ul>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-5 pb-20 lg:px-8">
        <div className="border border-slate-200 bg-slate-100/70 p-6 text-sm leading-relaxed text-slate-600">
          We do not reproduce standard text. Questions are written in product engineering language,
          firmware, interfaces, remote access, SBOM, and mapped to requirement themes using versioned
          internal mappings.
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
